export default "__VITE_ASSET__DCl3mS3v__"